import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { PAYMENT_URL, COMPLETE_EDITION_COVER, offerChecklist } from '../data/offer';
export function OfferSummary() {
  return <section id="offer" className="bg-[#f7f3ea] scroll-mt-12" data-id="element-147" data-mp="1f1pvewk7r3oa">
      <div className="mx-auto w-full max-w-5xl px-4 py-14 sm:px-6 sm:py-20" data-id="element-148" data-mp="1ez3l4p5xua2d">
        <div className="border-2 border-navy-900 bg-white" data-id="element-149" data-mp="1a2mo15grgld5">
          <div className="rule-ticks h-[6px] w-full" aria-hidden="true" data-id="element-150" data-mp="mbzb25rzn5jq" />
          <div className="grid gap-8 p-5 sm:p-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-10 lg:p-10" data-id="element-151" data-mp="hdfsmfclsbw4">
            <div className="bg-navy-900 p-5" data-id="element-152" data-mp="w2bv7wvw4wpc">
              <img src={COMPLETE_EDITION_COVER} alt="Cover of the Math Made Ready 2026 Complete Edition" className="mx-auto block w-full max-w-[260px] shadow-[0_18px_36px_-16px_rgba(0,0,0,0.9)] ring-1 ring-white/10" data-id="element-153" data-mp="w33tjfgvh8jb" />
            </div>

            <div className="flex flex-col" data-id="element-154" data-mp="3urj3x3oqyly9">
              <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-navy-900 sm:text-3xl lg:text-4xl" data-id="element-155" data-mp="3uqhpqqcfpjcb">
                Get the Complete MATH MADE READY 2026 Edition.
              </h2>

              <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-156" data-mp="1lb6lv65zgid8">
                {offerChecklist.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-navy-700" data-id="element-157" data-mp="1q9zykwdg45cc">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center bg-brand-emerald/15 text-[#1a8c42]" aria-hidden="true" data-id="element-158" data-mp="tltr81p52yud">
                      <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-159" data-mp="12mru2gnud0bd" />
                    </span>
                    {item}
                  </li>)}
              </ul>

              <div className="mt-8 border-t-2 border-dashed border-navy-900/15 pt-6" data-id="element-160" data-mp="2dzm1nuwxv4pm">
                <p className="font-pixel text-3xl leading-none text-navy-900 sm:text-4xl" data-id="element-161" data-mp="2ixdrmje0wgr6">
                  $19 USD
                </p>
                <p className="mt-3 text-sm text-navy-700/70" data-id="element-162" data-mp="1obqcwn7o5zil">
                  One-time payment • Instant digital access • No physical
                  shipment.
                </p>

                <a href={PAYMENT_URL} className="group mt-6 inline-flex w-full items-center justify-center gap-2 border-b-4 border-[#b47a08] bg-brand-gold px-5 py-4 font-pixel text-[10px] uppercase leading-none tracking-[0.08em] text-navy-900 transition-[transform,background-color] duration-150 ease-out hover:bg-[#ffc23f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy-900 active:translate-y-[2px] sm:px-6 sm:text-xs" data-id="element-163" data-mp="236wff07k3g76">
                  Get Instant Access — $19 USD
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-164" data-mp="rs93wef8d5om" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}